const API_ENDPOINTS = {
  ATHLETE_DETAILS: "/api/athlete/details",
  ATHLETE_STATS: "/api/athlete/get-athlete-stats",
  ATHLETE_HIGHLIGHTS: "/api/athlete/highlights/view-all",
  ATHLETE_POSTS: "/api/athlete/post/view-all",

  TEAM_DETAILS: "/api/team/view-details",
  TEAM_HIGHLIGHTS: "/api/team/highlights/view-all",
  TEAM_POSTS: "/api/team/post/view-all",

  CHALLENGE_DETAILS: "/api/challenges/view-by-id",
  CHALLENGE_SUBSCRIBER_ATHLETE_LIST:
    "/api/challenges/get-subscriber-athlete-list",

  EVENT_DETAILS: "/api/event/get-event-detail-by-id",
  EVENT_JOINED_TEAMS: "/api/event/joined-teams",

  PRIMARY_SPORT_DETAILS: "/api/primary-sport/details",
  EARLY_ACCESS_ADD_USER: "/api/guest/early-access/add-user",
  EARLY_ACCESS_VERIFY_OTP: "/api/guest/early-access/verify-otp",
  EARLY_ACCESS_RESEND_OTP: "/api/guest/early-access/resend-otp",

  ATHLETE_POST_BY_ID: "/api/athlete/post/view-by-id",
  ATHLETE_HIGHLIGHT_BY_ID: "/api/athlete/highlights/view-by-id",
};

export default API_ENDPOINTS;
